import { S } from '../../regureStyles';

const Card = ({ title, children }) => {
  return (
    <div style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 16, padding: 24, marginBottom: 20 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: S.textPrimary, marginBottom: 16, textTransform: 'uppercase', letterSpacing: 0.8 }}>{title}</div>
      {children}
    </div>
  );
};

export default Card;
